import { RobotModel } from '@/interfaces'

export const HORST_800: RobotModel = {
  id: '665b4210-22eb-4b64-86e2-e86b5aab46bc',
  name: 'HORST800 G2',
  systemDisplayConfiguration: {
    image: new URL(`/src/assets/systems/600.png`, import.meta.url).href, //TODO: Add the right image
  },
  maintenanceDisplayConfiguration: {
    image: new URL(`/src/assets/robots/600.png`, import.meta.url).href, //TODO: Add the right image
  },
  axisMaxRotations: [7_725_000, 6_100_000, 17_076_000, 5_171_000, 8_514_000, 22_503_000], //TODO: Update the axisMaxRotation

  selectable: true,
}
